import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const usedPlatformApisSiteConfig: SiteConfigFn<never> = ({ api }) => {
	return {
		shouldLoadSiteFeature: api.features.isActive('platform'),
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'usedPlatformApis'

export const config = { site: usedPlatformApisSiteConfig, name }
